<template>
  <footer class="app-footer">
    
    <div class="container-fluid d-flex flex-column flex-md-row justify-content-between align-items-center">
      
      <!-- ESQUERDA -->
      <div class="footer-left">
        © {{ year }} Dailypag
      </div>

      <!-- CENTRO -->
      <div class="footer-center">
        <a href="#">Termos</a>
        <a href="#">Privacidade</a>
        <a href="#">Suporte</a>
      </div>

      <!-- DIREITA -->
      <div class="footer-right">
        v1.0.0
      </div>

    </div>

  </footer>
</template>

<script>
export default {
  computed: {
    year() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>

/* FOOTER BASE */
.app-footer {
  width: 100%;
  background: #fff;
  border-top: 1px solid #eee;
  padding: 12px 0;
  /* remove position relative/fixed anterior */
}

/* CONTEÚDO */
.footer-left,
.footer-center,
.footer-right {
  font-size: 13px;
  color: #666;
}

/* LINKS */
.footer-center a {
  margin: 0 10px;
  text-decoration: none;
  color: #666;
  transition: 0.2s;
}

.footer-center a:hover {
  color: #0d6efd;
}

/* RESPONSIVO */
@media (max-width: 768px) {
  .app-footer {
    text-align: center;
  }

  .footer-center {
    margin: 8px 0;
  }
}

</style>